import { ProductSeries, SkinProductOption } from '../types/productTypes'
import { EcommercePayloadItem, EventEcommercePayload } from './AnalyticsEvents'
import { getProductDisplayNames } from '../utils/getProductDisplayNames'
import { getTopLevelMenuCategoryForProduct } from '../products/productUtils'
import SelectorScreenMenuType from '../selector-screen/SelectorScreenMenuType'
import { BuildConfig } from '../config/BuildConfig'

export function getAnalyticsSeriesName(series: ProductSeries): 'Iconic' | 'Pro Series'
export function getAnalyticsSeriesName(series: ProductSeries | null): 'Iconic' | 'Pro Series' | null
export function getAnalyticsSeriesName(series: null): null

export function getAnalyticsSeriesName(series: ProductSeries | null): 'Iconic' | 'Pro Series' | null {
  if (series === ProductSeries.Pro) {
    return 'Pro Series'
  } else if (series === ProductSeries.Iconic) {
    return 'Iconic'
  }

  return null
}

export type ListInfo = {
  name: string
  id: string
}

export type AnalyticsProductInfo = {
  name: string
  secondaryName: string | null
  itemId: string
  category: string
  variant: string | null
}

export function getAnalyticsProductInfo(skinProduct: SkinProductOption): AnalyticsProductInfo {
  const names = getProductDisplayNames(skinProduct)
  const category = getTopLevelMenuCategoryForProduct(skinProduct, SelectorScreenMenuType.TopLevel)

  return {
    name: names.primary,
    secondaryName: names.secondary,
    itemId: skinProduct.itemNo,
    category: category,
    variant: skinProduct.color,
  }
}

function parsePriceStringAsFloat(price: string | null): number | null {
  if (price == null) {
    return null
  }

  const parsed = parseFloat(price)

  if (isNaN(parsed)) {
    return null
  }

  return parsed
}

export function getEcommerceItemFrom(
  product: AnalyticsProductInfo,
  quantity: number,
  price: string | null,
  listInfo: ListInfo,
): EcommercePayloadItem {

  return {
    item_name: [product.name, product.secondaryName ?? ''].filter(it => it.trim().length > 0).join(' '),
    item_id: product.itemId,
    item_brand: BuildConfig.brand.brandName,
    item_list_name: listInfo.name,
    item_list_id: listInfo.id,
    item_category: product.category,
    item_variant: product.variant,
    price: parsePriceStringAsFloat(price),
    quantity: quantity > 0 ? quantity : null
  }
}

export function getEcommercePayloadFrom(
  productList: {
    product: AnalyticsProductInfo
    quantity: number
    price: string | null
  }[],
  listInfo: ListInfo,
): EventEcommercePayload {
  const ecomItems = productList.map(item => getEcommerceItemFrom(item.product, item.quantity, item.price, listInfo))
  const value = ecomItems.reduce((accum: number, curr) => {
    // inlining this causes a seemingly incorrect lint error
    const currPrice = curr.price ?? 0
    return accum + currPrice
  }, 0)

  return {
    currency: BuildConfig.brand.currencyCode,
    value: value,
    items: ecomItems
  }
}